// extracted by mini-css-extract-plugin
export var actions = "_8q-8";
export var arrow = "_8q-5";
export var card = "_8q-0";
export var cardWrapper = "_8q-9";
export var fieldName = "_8q-3";
export var newValue = "_8q-6";
export var oldValue = "_8q-4";
export var orangeGlowFade = "_8q-c";
export var productSection = "_8q-1";
export var scrollToBottom = "_8q-b";
export var scrollToBottomAnchor = "_8q-a";
export var scrollToBottomIcon = "_8q-d";
export var showAllButton = "_8q-7";
export var table = "_8q-2";